import { useState, useRef, useEffect } from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import ComponentTable from '../../../Components/Table/Index';
import { Column } from '../../../Components/Table/Types';
import { BoxButtons, Button } from '../../../Styles/ScreenStyle';
import { HeaderComponent } from '../../../../shared/components/HeaderComponent';
import * as Icon from '@mui/icons-material/';
import { useNavigate } from 'react-router-dom';
import { Form, Formik, Field } from 'formik';
import { FornecedorAtualizar, FornecedorCadastrar } from '../../../../routes/RoutesNames';
import { IconButton } from '@mui/material';
import { useSelector } from 'react-redux';
import { Helpers } from '../../../Components/Helpers/Helpers';
import FornecedorController from '../../../../controllers/FornecedorController';
import { useConfirmacao } from '../../../../hooks/useConfirmacao';
import SnackAlert from '../../../Components/AlertComponents/Snack/SnackAlert';
import { Snack } from '../../../Components/Types';

interface Row {
  BtnEditar?: JSX.Element;
  BtnExcluir?: JSX.Element;
  for_id: number;
  for_nome: string;
  for_endereco: string;
  for_cidade: string;
  for_telefone: string;
  for_celular: string;
  for_datanascimento: string;
  for_ativo: string;
}

export default function Fornecedor() {
  const ref = useRef<HTMLButtonElement>(null);
  // @ts-ignore - .
  const userId = useSelector((state) => state.Authentication.userId);
  //const [modal, setModal] = useState<Modal | any>(null);
  const [snack, setSnack] = useState<Snack | null>(null);
  const navigate = useNavigate();
  const { confirmar, dialogoConfirmacao } = useConfirmacao();

  const tableColumns: Column[] = ([
    { id: 'BtnEditar', label: '', width: 60, minWidth: 0 },
    { id: 'BtnExcluir', label: '', width: 60, minWidth: 0 },
    { id: 'Id', label: 'Id', minWidth: 0 },
    { id: 'Nome', label: 'Nome', minWidth: 0 },
    { id: 'Endereco', label: 'Endereco', minWidth: 0 },
    { id: 'Cidade', label: 'Cidade', minWidth: 0 },
    { id: 'Telefone', label: 'Telefone', minWidth: 0 },
    { id: 'Celular', label: 'Celular', minWidth: 0 },
    { id: 'DataNascimento', label: 'Data de nascimento', minWidth: 0 },
    { id: 'Situacao', label: 'Situação', minWidth: 0 },
  ]);

  const [tableRows, setTableRows] = useState<Row[]>([]);

  useEffect(() => {
    ref?.current?.click();
  }, []);

  const handleNavigation = async (): Promise<void> => {
    navigate(FornecedorCadastrar);
  };

  const handleEditItem = (item: Row) => {
    navigate(FornecedorAtualizar.replace(':id', item?.for_id.toString() ?? ''));
  };

  const handleDeleteItem = async (for_id: number) => {
    const request: any = { UsuId: userId, FornecedorId: for_id };
    const response = await FornecedorController.Excluir(request);

    if (response.StatusCode === 204) {
      setSnack({
        title: 'Concluído',
        description: 'Fornecedor excluído com sucesso!',
        colorType: '#1B5E20',
      });
      //Força o Grid a ser recarregado!
      ref?.current?.click();
    } else {
      setSnack({
        title: 'Erro',
        description: 'Erro ao excluir o fornecedor!',
        colorType: '#C62828',
      });
    }
  };

  const handleSubmit = async (values: any, { setSubmitting }: any) => {
    console.log(values);
    setSubmitting(false);

    const DataRows: any = [];
    const Response = await FornecedorController.Listar({ ...values, CpfCnpj: '' });

    if (Response.StatusCode === 200 && Response?.Data?.length > 0) {
      Response.Data.map((item: Row) => {
        DataRows.push({
          BtnEditar: (
            <IconButton
              onClick={() => handleEditItem(item)}
              aria-label='edit'
              color='info'
              title='Editar'
            >
              {' '}
              <Icon.Edit />
            </IconButton>
          ),
          BtnExcluir: (
            <IconButton
              onClick={() =>
                confirmar(
                  `Excluir o fornecedor "${item.for_nome ?? ''}"? Esta ação não pode ser desfeita.`,
                  () => handleDeleteItem(item.for_id)
                )
              }
              aria-label='delete'
              color='error'
              title='Excluir'
            >
              <Icon.Delete />
            </IconButton>
          ),
          Id: item.for_id,
          Nome: item.for_nome,
          Endereco: item.for_endereco,
          Cidade: item.for_cidade,
          Telefone: Helpers.PhoneMaskShowing(item.for_telefone),
          Celular: Helpers.CellPhoneMaskShowing(item.for_celular),
          DataNascimento: Helpers.DateFormatTableShowing(
            item.for_datanascimento
          ),
          Situacao: item.for_ativo == 'S' ? 'Ativo' : 'Inativo',
        });

        setTableRows(DataRows);
      });
    } else if (Response.StatusCode === 204 && Response?.Data?.length === 0) {
      setSnack({
        title: '',
        description: 'Não há registros cadastrados.',
        colorType: '#FFC107',
      });
    } else {
      setSnack({
        title: 'Erro',
        description: Response?.Data,
        colorType: '#C62828',
      });
    }
  };

  const CloseModal = (): void => {
    setSnack(null);
  };

  const initialValues = {
    FornecedorId: null,
    Nome: '',
    Celular: '',
    Endereco: '',
    Bairro: '',
    Cidade: '',
    DataNascimento: null,
  };

  return (
    <Box
      component='form'
      sx={{
        '& .MuiTextField-root': { m: 1, width: '35ch' },
      }}
      noValidate
      autoComplete='off'
    >
      <div style={{ paddingBottom: 30 }}>
        <HeaderComponent text={'FORNECEDORES'} className={'mb-5'} />

        {
          snack !== null && (
            <SnackAlert modalProps={snack} onClose={CloseModal} />
          )
          // <ModalAlert title={showModal.title} description={showModal.description} onClose={CloseModal} />
        }

        <Formik
          initialValues={initialValues}
          //validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting, errors, handleSubmit }) => (
            <Form>
              <BoxButtons>
                <Button
                  ref={ref}
                  type='submit'
                  variant='contained'
                  color='primary'
                  onClick={handleSubmit}
                  startIcon={<Icon.Search />}
                >
                  Buscar
                </Button>
                <Button
                  variant='contained'
                  onClick={handleNavigation}
                  color='success'
                  startIcon={<Icon.Add />}
                >
                  Incluir
                </Button>
              </BoxButtons>

              <Field
                //required
                //error
                name='FornecedorId'
                as={TextField}
                id='outlined-password-input'
                label='Código'
                type='number'
                autoComplete='current-password'
              />
              <Field
                name='Nome'
                as={TextField}
                label='Nome'
                type='text'
                error={Boolean(errors?.Nome)}
                helperText={errors?.Nome}
              />
              <Field
                name='Celular'
                as={TextField}
                //id="outlined-password-input"
                label='Celular'
                type='text'
                error={Boolean(errors?.Celular)}
                helperText={errors?.Celular}
                onInput={(e: any) => Helpers.CellPhoneMaskEditing(e)}
              />
              <Field
                name='Endereco'
                as={TextField}
                id='outlined-password-input'
                label='Endereço'
                type='text'
                error={Boolean(errors?.Endereco)}
                helperText={errors?.Endereco}
                autoComplete='current-password'
              />
              <Field
                name='Bairro'
                as={TextField}
                id='outlined-password-input'
                label='Bairro'
                type='text'
                error={Boolean(errors?.Bairro)}
                helperText={errors?.Bairro}
                autoComplete='current-password'
              />
              <Field
                name='Cidade'
                as={TextField}
                id='outlined-password-input'
                label='Cidade'
                type='text'
                error={Boolean(errors?.Cidade)}
                helperText={errors?.Cidade}
                autoComplete='current-password'
              />
              <Field
                name='DataNascimento'
                as={TextField}
                label='Data de nascimento'
                InputLabelProps={{ shrink: true }}
                type='date'
                error={Boolean(errors?.DataNascimento)}
                helperText={errors?.DataNascimento}
              />
            </Form>
          )}
        </Formik>
      </div>
      <ComponentTable columns={tableColumns} rows={tableRows} />
      {dialogoConfirmacao}
    </Box>
  );
}
